/** Junta classes de CSS Modules, ignorando valores falsos. `cx(s.card, active && s.active)`. */
export type ClassValue = string | false | null | undefined | 0;

export function cx(...values: ClassValue[]): string {
  let out = '';
  for (const v of values) {
    if (v) out = out ? `${out} ${v}` : v;
  }
  return out;
}
